import React, { useRef, useEffect, useState } from 'react';
import Input from '../Components/InputForm';
import VerifyOtp from '../Components/VerifyOtp';
import lodash from 'lodash';
import apiRequest from "../../../../utils/api.request";
import config from '../../../../config.json';
import { vaccinationApiRequestBody } from "../Utils/vaccinationApiRequestBody";
import { _getErrorMessage } from "../Utils/getErrorMessage"

import Thankyou from '../Components/ThankYou';
import CancelModal from '../Components/CancelModal';

import './profileDetails.css';


const get_otp_url = config.covid_vacc_base_url + "v1/send-otp-partner/";
const resend_otp_url = config.covid_vacc_base_url + "v1/resend-otp-partner/";
const verify_associate_jhh_url = config.covid_vacc_base_url + "v1/verify-associate-jhh/";
const otpValidationRegex = "([0-9]{6}){1}$";


const ProfileDetails = ({ showCorporateFlow, userInfo, profileDetails, handleUserJourneyChange, t, callbackAfterOtpVerify, closeWindowOnThankYouDone = false }) => {
  const [showButtons, _setShowButtons] = useState(true);
  const [otp, _setOtp] = React.useState("");
  const [errorOtp, _setErrorOtp] = React.useState("");
  const [getOtpError, _setGetOtpError] = React.useState("");
  const [validateOtpError, _setValidateOtpError] = React.useState("");
  const [showThankYou, _setShowThankYou] = React.useState(false);
  const [cancelClicked, _setCancelClicked] = useState(false);
  const [getOtpDisabled, _setGetOtpDisabled] = useState();
  const [validateOtpDisabled, _setValidateOtpDisabled] = useState(false); 
  const [resendOtpDisabled, _setResendOtpDisabled] = React.useState(false);
  const otpId = useRef("");
  const _isMounted = useRef();
 
  const [resendOtpCounter, _setResendOtpCounter] = React.useState(0);

  const handleCancelClicked = () => {
    _setCancelClicked(true);
  }

  const handleNoClicked = () => {
    _setCancelClicked(false);
  }

  useEffect(() => {
    if (resendOtpCounter > 0) {
      _isMounted.current = setTimeout(() => {
        _setResendOtpCounter((previousOtpCounter) => previousOtpCounter - 1);
      }, 1000);
    }

    return () => {
      if (_isMounted.current) clearTimeout(_isMounted.current);
    };
  }, [resendOtpCounter]);

  const _handleOtpInput = (e) => {
    if (e.target.value.match(/^[0-9]+$/) !== null || e.target.value === "") {
      _setOtp(e.target.value);
      _setErrorOtp("");
      _setValidateOtpError("");
    }
  }

  const _validateInput = (input, regex) => {
    const regexTester = new RegExp(regex);
    return regexTester.test(input);
  }

  const _handleGetOtpClicked = async () => {
    try {
      if (userInfo.name === "" || userInfo.gender === "" || userInfo.date_of_birth === "" || userInfo.phone === "" || userInfo.jhhID === "") {
        return;
      }

      let dataObj = {};
      dataObj = vaccinationApiRequestBody( dataObj, profileDetails);

      _setGetOtpDisabled(true);

      const response = await apiRequest(get_otp_url, dataObj, true);

      if (lodash.get(response, "status") !== "success") {
        _setGetOtpError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
        _setGetOtpDisabled(false);
        return;
      }

      _setGetOtpError("");
      _setShowButtons(false);

      otpId.current = lodash.get(response, "otp_id");
      _setResendOtpCounter(60);
    } catch (error) {

    }
  }
  const _handleResendOtpClick = async () => {
    if (resendOtpDisabled) return;
    try {
      let dataObj = {
        "otp_id": otpId.current
      }
        dataObj = vaccinationApiRequestBody(dataObj, profileDetails);

      _setResendOtpDisabled(true);
      const response = await apiRequest(resend_otp_url, dataObj, true);
      _setResendOtpDisabled(false);

      if (lodash.get(response, "status") !== "success") {
        _setValidateOtpError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
        return;
      }

      _setValidateOtpError("");
      otpId.current = lodash.get(response, "otp_id");
      _setResendOtpCounter(60);

    } catch (error) {

    }
  }

  const _handleProceedClick = async () => {
    try {
      if (!_validateInput(otp, otpValidationRegex)) {
        _setErrorOtp("Please enter 6 digit otp.");
        return;
      }

      _setErrorOtp("");
      let dataObj = {
        "otp_details": {
          "otp_id": otpId.current,
          "otp": otp
        }
      }
        dataObj = vaccinationApiRequestBody(dataObj, profileDetails);

      _setValidateOtpDisabled(true);
      const response = await apiRequest(verify_associate_jhh_url, dataObj, true);
      _setValidateOtpDisabled(false);

      if (lodash.get(response, "status") !== "success") {
        _setValidateOtpError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
        return;
      }

      _setValidateOtpError("");
      _setResendOtpCounter(0);
      if(callbackAfterOtpVerify){
        callbackAfterOtpVerify()
      }
      _setShowThankYou(true)
    } catch (error) {
      throw (error);
    }
  }

  return (
    <div>
      <div className="express-interest-question">
        <div className="express-interest-left-col">
          <div className="express-interest-question-heading">{t("EOI_PROFILE_DETAILS")}</div>
          <div className="express-interest-question-description">
            {t("EOI_PROFILE_DETAILS_TEXT")}
          </div>
          {showCorporateFlow && !showThankYou &&
            <div>
              <div onClick={() => handleUserJourneyChange("different-jhh-id")} className="express-interest-link">
                {t("EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_LINK")}
              </div>
              <div onClick={() => handleUserJourneyChange("create-new-jhh-id")} className="express-interest-link">
                {t("EOI_CREATE_NEW_JIOHEALTHHUB_ID_LINK")}
              </div>
            </div>
          }
        </div>
        {showCorporateFlow &&
        <div className="express-interest-right-col">
          <Input
            label={t("EOI_JIOHEALTHHUB_ID")}
            type="text"
            addClassInput="express-interest-add-input-form disabled"
            addClassLabel="profile-form-label"
            value={userInfo.jhhID}
            readOnly={true}
          />
          <Input
            label={t("EOI_NAME")}
            type="text"
            addClassInput="express-interest-add-input-form disabled"
            addClassLabel="profile-form-label"
            value={userInfo.name}
            readOnly={true}
          />
          <Input
            type="text"
            label={t("EOI_DATE_OF_BIRTH")}
            addClassInput="express-interest-add-input-form disabled"
            addClassLabel="profile-form-label"
            value={userInfo.date_of_birth}
            readOnly={true}
          />
          <Input
            type="text"
            label={t("EOI_PHONE_NUMBER")}
            addClassInput="express-interest-add-input-form disabled"
            addClassLabel="profile-form-label"
            value={userInfo.phone}
            readOnly={true}
          />
          <Input
            label={t("EOI_GENDER")}
            type="text"
            addClassInput="express-interest-add-input-form disabled"
            addClassLabel="profile-form-label"
            value={String(userInfo.gender) === "1" ? "Male" : "Female"}
            readOnly={true}
          />
          {
            showButtons &&
            <div className="express-interest-modal-buttons">
              <Input
                addClassInput="express-interest-modal-button-no express-interest-modal-button-padding"
                type="button"
                value={t("EOI_CANCEL")}
                onClick={() => handleCancelClicked()}
              />
              <Input
                disabledValue={getOtpDisabled}
                type="button"
                addClassInput={`express-interest-modal-button-yes 
                express-interest-modal-button-padding 
                ${getOtpDisabled ? "express-interest-modal-button-disabled" : ""}`}
                value={t("EOI_GET_OTP")}
                onClick={() => _handleGetOtpClicked()}
              />
            </div>
          }
          {(getOtpError && getOtpError.length) && <><p className="form-element-error create-acc-get-otp-error">{_getErrorMessage(getOtpError)}</p></>}
        </div>
        }
        {!showCorporateFlow &&
        <div>
          <button 
            className={`express-interest-journey-button`} 
            onClick={() => handleUserJourneyChange("different-jhh-id")}
          >{t("EOI_EXISTING_USER")}</button>
          <button
            className={`express-interest-journey-button express-interest-create-new-button`}
            onClick={() => handleUserJourneyChange("create-new-jhh-id")}
          >  {t("EOI_CREATE_NEW")}</button>        
        </div>
        }
      </div>
      {
        !showButtons &&
        <VerifyOtp
          otp={otp}
          resendOtpCounter={resendOtpCounter}
          error={_getErrorMessage(errorOtp)}
          validateOtpError={_getErrorMessage(validateOtpError)}
          buttonsDisabled={showThankYou}
          validateOtpDisabled={validateOtpDisabled}
          resendOtpDisabled={resendOtpDisabled}
          _handleOtpInput={_handleOtpInput}
          _handleResendOtpClick={_handleResendOtpClick}
          _handleCancelClick={handleCancelClicked}
          _handleProceedClick={_handleProceedClick}
          t={t}
          />
      }
      {showThankYou &&
        <Thankyou message={t("EOI_THANK_YOU_COMPONENT_PROFILE_VALIDATION_TEXT")} jhhId={userInfo.jhhID} _handleCancelClick={handleCancelClicked} profileDetails={profileDetails} t={t} closeWindowOnThankYouDone={closeWindowOnThankYouDone}/>
      }
      {cancelClicked && <CancelModal handleNoClicked={handleNoClicked} />}
    </div>
  );
};

export default ProfileDetails;